import {
  Box,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import { useMemo } from "react";
import { useParams } from "react-router-dom";
import ExternalLinkButton from "src/components/Button/ExternalLinkButton";
import CssPagination from "src/components/Pagination/CssPagination";
import Empty from "src/components/utils/Empty";
import { NETWORK } from "src/config/constants";
import { POOL_IDS } from "src/config/poolsConfig";
import usePagination from "src/hooks/usePagination";
import useTravaPrice from "src/hooks/useTravaPrice";
import { numberWithCommas, toFixed } from "src/services/utils";

const useStyle = makeStyles((theme) => ({
  firstCell: {
    position: "sticky",
    left: 0,
    zIndex: 1,
    backgroundColor: theme.palette.background.headerDefault,
  },
  firstBody: {
    position: "sticky",
    left: 0,
    zIndex: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function ActionDataTable({ actionData }) {
  const cls = useStyle();
  const { pool } = useParams();

  const network = useMemo(() => {
    if (pool === POOL_IDS.TRAVA_BSC) return NETWORK.BSC_MAINNET;
    else if (pool === POOL_IDS.TRAVA_FTM) return NETWORK.FTM_MAINNET;
    else return NETWORK.ETH_MAINNET;
  }, [pool]);

  const price = useTravaPrice(network);

  const realData = useMemo(() => {
    if (price) {
      return actionData.map((element) => {
        const tTokensEPS = element.tTokenEPS;
        const dTokenEPS = element.dTokenEPS;
        const depositAPR = (tTokensEPS * 365 * 24 * 60 * 60 * price) / element.totalSupply;
        const borrowAPR = (dTokenEPS * 365 * 24 * 60 * 60 * price) / element.totalBorrow;
        return { ...element, depositAPR, borrowAPR };
      });
    }
    return [];
  }, [price, actionData]);
  const len = realData.length;
  const { data, jump, maxPage, currentPage } = usePagination(realData);

  return (
    <>
      <TableContainer style={{ borderRadius: "10px" }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell className={cls.firstCell} style={{ minWidth: "50px" }}>
                <Typography>Token</Typography>
              </TableCell>
              <TableCell style={{ cursor: "pointer", minWidth: "50px" }}>
                <Typography>Deposited</Typography>
              </TableCell>
              <TableCell style={{ cursor: "pointer", minWidth: "50px" }}>
                <Typography>Deposited APR</Typography>
              </TableCell>
              <TableCell style={{ cursor: "pointer", minWidth: "50px" }}>
                <Typography>Borrowed</Typography>
              </TableCell>
              <TableCell style={{ cursor: "pointer", minWidth: "50px" }}>
                <Typography>Borrow APR</Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((rowData, index) => (
              <TableRow key={index}>
                <TableCell className={cls.firstBody}>
                  <Box display="flex" justifyContent="flex-start" alignItems="center">
                    <Typography>{rowData.symbol}</Typography>
                    <ExternalLinkButton hash={rowData.address} config={{ pool }} />
                  </Box>
                </TableCell>
                <TableCell>
                  <Typography>{`$${numberWithCommas(toFixed(rowData.deposit, 2))}`}</Typography>
                </TableCell>
                <TableCell>
                  <Typography>{`${numberWithCommas(toFixed(rowData.depositAPR * 100, 2))}%`}</Typography>
                </TableCell>
                <TableCell>
                  <Typography>{`$${numberWithCommas(toFixed(rowData.borrow, 2))}`}</Typography>
                </TableCell>
                <TableCell>
                  <Typography>{`${numberWithCommas(toFixed(rowData.borrowAPR * 100, 2))}%`}</Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {len === 0 && (
        <Box style={{ textAlign: "center", py: 3 }}>
          <Empty title="No Data" iconProps={{ style: { fontSize: "60px" } }} />
        </Box>
      )}
      {len > 0 && (
        <CssPagination
          mt={1}
          paginationProps={{ page: currentPage, count: maxPage, onChange: (_, page) => jump(page) }}
        />
      )}
    </>
  );
}
